import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';
import { IntercomService } from '@app/shared/services/intercom.service';
import { OnboardingAction, OnboardingItem, OnboardingService } from '../../onboarding.service';

@Component({
  standalone: false,
  selector: 'sbnb-onboarding-item',
  templateUrl: './onboarding-item.component.html',
  styleUrls: ['./onboarding-item.component.scss'],
})
export class OnboardingItemComponent implements OnInit {
  @Input() item: OnboardingItem;
  @Input() parentId: number;

  isMobile: boolean;

  constructor(
    private readonly onboardingService: OnboardingService,
    private readonly breakpointObserver: BreakpointObserver,
    private readonly intercomService: IntercomService
  ) { }

  ngOnInit(): void {
    this.breakpointObserver.observe(['(max-width: 960px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });
  }

  openActionLink(link: string) {
    window.location.href = link;
  }

  openTour(action: OnboardingAction) {
    this.intercomService.startTour(this.isMobile ? action.mobile_tour_id : action.tour_id);
  }

  markItemAsCompleted(item: OnboardingItem, parentId: number, completed: boolean) {
    this.onboardingService.markItemAsManuallyCompleted(item, parentId, completed);
  }

  expandCollapseChildren(item: OnboardingItem) {
    this.onboardingService.expandCollapseChildren(item, !item.children_expanded);
  }

  trackById = (index: number, obj: OnboardingItem): number => {
    return obj.id;
  };
}
